<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="12" >
            <a-form-model-item :label="language['gift_app_no']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="code" >
              <a-input v-model.trim="model.code" :placeholder="language['common.pleaseInput']+language['gift_app_no']"  :maxLength='30' :disabled='mainInfoDisable'></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" >
            <a-form-model-item :label="language['ipsys.eventName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <a-input v-model.trim="model.name" :placeholder="language['common.pleaseInput']+language['ipsys.eventName']" :maxLength='30' :disabled='mainInfoDisable' ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" />
          <a-col :span="12" >
            <a-form-model-item :label="language['gift_app_pre_time']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="forecastAt">
              <a-date-picker show-time value-format='YYYY-MM-DD HH:mm:ss' :placeholder="language['column.pleaseChoose']+language['gift_app_pre_time']" v-model="model.forecastAt" style="width: 100%"  :disabled='mainInfoDisable' />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" >
            <a-form-model-item :label="language['gift_app_start_time']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="startAt">
              <a-date-picker show-time value-format='YYYY-MM-DD HH:mm:ss'   :placeholder="language['column.pleaseChoose']+language['gift_app_start_time']" v-model="model.startAt" style="width: 100%" :disabled='mainInfoDisable' />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" >
            <a-form-model-item :label="language['gift_app_end_time']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="endAt">
              <a-date-picker show-time value-format='YYYY-MM-DD HH:mm:ss'   :placeholder="language['column.pleaseChoose']+language['gift_app_end_time']" v-model="model.endAt" style="width: 100%" :disabled='mainInfoDisable' />
            </a-form-model-item>
          </a-col>
          <a-col :span="12" >
            <a-form-model-item :label="language['gift_questionnaire_start_time']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="questionnaireTime">
              <a-date-picker show-time value-format='YYYY-MM-DD HH:mm:ss'   :placeholder="language['column.pleaseChoose']+language['gift_questionnaire_start_time']" v-model="model.questionnaireTime" style="width: 100%" :disabled='mainInfoDisable' />
            </a-form-model-item>
          </a-col>
          <a-col :span="24" />

          <a-col :span="24" >
            <a-form-model-item :label="language['gift_app_icon']" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="icon">
              <j-image-upload   upload-source='gift'     :number='1' isMultiple  v-model="model.icon" ></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" >
            <a-form-model-item :label="language['gift_app_blessing']" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="greetings">
              <a-textarea v-model="model.greetings" :maxLength='200'  :auto-size="{ minRows: 5, maxRows: 8 }" :placeholder="language['common.pleaseInput']+language['gift_app_blessing']" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24" >
            <a-form-model-item :label="language['gift_app_customer_info']" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="customServiceInfo">
              <a-textarea v-model="model.customServiceInfo" :maxLength='200' :auto-size="{ minRows: 3, maxRows: 5 }" :placeholder="language['common.pleaseInput']+language['gift_app_customer_info']" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['gift_app_description']" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="explanation">
<!--              <a-textarea v-model="model.explanation" :maxLength='300' :auto-size="{ minRows: 5, maxRows: 8 }"  :placeholder="language['common.pleaseInput']+language['gift_app_description']" />-->
              <j-editor v-model="model.explanation"  :plugins="plugins" :limit="300" :height="10" />
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="24" >
            <a-form-model-item :label="language['gift.app.event.qa']" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="appFaq">
              <j-editor v-model="model.appFaq"  :plugins="plugins" :limit="300" :height="10" />
&lt;!&ndash;              <a-textarea v-model="model.appFaq" :maxLength='200' :auto-size="{ minRows: 3, maxRows: 5 }" :placeholder="language['common.pleaseInput']+language['gift.app.event.qa']" />&ndash;&gt;
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24" >
            <a-form-model-item :label="language['gift.app.permission.prompt']" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="noPermissionInfo">
              <j-editor v-model="model.noPermissionInfo"  :plugins="plugins":limit="300" :height="10" />
<!--
              <a-textarea v-model="model.noPermissionInfo" :maxLength='200' :auto-size="{ minRows: 3, maxRows: 5 }" :placeholder="language['common.pleaseInput']+language['gift.app.permission.prompt']" />
-->
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-col :span="24" >
              <a-form-model-item :label="language['gift_app_event_terms']" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="clause">
                <j-editor v-model="model.clause"  :plugins="plugins"  :limit="300" :height="10" />
              </a-form-model-item>
            </a-col>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="' * '+language['gift_app_delivery_date']" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="appDeliveryTable.loading"
          :columns="appDeliveryTable.columns"
          :dataSource="appDeliveryTable.dataSource"
          :maxHeight="300"
          :disabled='mainInfoDisable'
          :rowNumber="true"
          :rowSelection="!mainInfoDisable"
          :actionButton="!mainInfoDisable"
          :maxNumber = 10
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import { getAction } from '@/api/manage'
  import { FormTypes,getRefPromise,VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'AppForm',
    mixins: [JEditableTableModelMixin],
    components: {
    },
    data() {
      const { language } = this.$store.getters;
      return {
        //plugins:"['a11ychecker','advlist','advcode','advtable','autolink','checklist','export', 'lists','link','image','charmap','preview','anchor','searchreplace','visualblocks','powerpaste','fullscreen','formatpainter','insertdatetime','media','table','help','wordcount']",
        //plugins:"['lists textcolor wordcount contextmenu']",
        plugins:'lists link table textcolor wordcount contextmenu fullscreen',
        //toolbar:"' bold | italic | h1 | h2 | h3 | forecolor | alignleft aligncenter alignright alignjustify |  bullist numlst checklist outdent indent | removeformat | a11ycheck code table help'",
        toolbar:"' undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat '",
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        model:{
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
           code: [
              { required: true, message: language['common.pleaseInput']+language['gift_app_no']},
           ],
           name: [
              { required: true, message: language['common.pleaseInput']+language['ipsys.eventName']},
           ],
           icon: [
              { required: true, message: language['common.pleaseInput']+language['gift_app_icon']},
           ],
           greetings: [
              { required: true, message: language['common.pleaseInput']+language['gift_app_blessing']},
           ],
           explanation: [
              { required: true, message: language['common.pleaseInput']+language['gift_app_description']},
           ],
           customServiceInfo: [
              { required: true, message: language['common.pleaseInput']+language['gift_app_customer_info']},
           ],
           /*appFaq: [
              { required: true, message: language['common.pleaseInput']+language['gift.app.event.qa']},
           ],*/
           noPermissionInfo: [
              { required: true, message: language['common.pleaseInput']+language['gift.app.permission.prompt']},
           ],
           clause: [
              { required: true, message: language['common.pleaseInput']+language['gift_app_event_terms']},
           ],
           forecastAt: [
              { required: true, message: language['common.pleaseInput']+language['gift_app_pre_time']},
           ],
           startAt: [
              { required: true, message: language['common.pleaseInput']+language['gift_app_start_time']},
           ],
           endAt: [
              { required: true, message: language['common.pleaseInput']+language['gift_app_end_time']},
           ],
           questionnaireTime: [
              { required: true, message: language['common.pleaseInput']+language['gift_questionnaire_start_time']},
           ],
        },
        refKeys: ['appDelivery', ],
        tableKeys:['appDelivery', ],
        activeKey: 'appDelivery',
        // app_delivery
        appDeliveryTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: language['ipsys.startDate'],
              key: 'startTime',
              type: FormTypes.date,
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue:'',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: language['ipsys.endDate'],
              key: 'endTime',
              type: FormTypes.date,
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue:'',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: language['ipsys.desc'],
              key: 'title',
              type: FormTypes.input,
              width:"200px",
              maxLength:8,
              placeholder: '请输入${title}',
              defaultValue:'',
              validateRules: [{ required: true, message: '${title}不能为空'},
                {
                  maxlength:8,
                  message: '${title}长度不能超过8'
                }
              ],
            },
          ]
        },
        mainInfoDisable:false,
        url: {
          add: "/gift/app/add",
          edit: "/gift/app/edit",
          queryById: "/gift/app/queryById",
          appDelivery: {
            list: '/gift/app/queryAppDeliveryByMainId'
          },
        }
      }
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
    },
    created () {
    },
    methods: {
      addBefore(){
        this.appDeliveryTable.dataSource=[]
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        this.$nextTick(() => {
        })
        this.mainInfoDisable = this.model.status == '1';
        // 加载子表数据
        if (this.model.code) {
          let params = { id: this.model.code }
          this.requestSubTableData(this.url.appDelivery.list, params, this.appDeliveryTable)
        }
      },
      //校验所有一对一子表表单
      validateSubForm(allValues){
          if (this.model.forecastAt > this.model.startAt){
             this.$message.error(this.language['gift_app_time_error_1']);
             return ;
          }
          if (this.model.startAt > this.model.endAt){
             this.$message.error(this.language['gift_app_time_error_2']);
             return ;
          }
          var appDeliveryList = allValues.tablesValue[0].values;
          if (appDeliveryList.length===0){
             this.$message.error(this.language['gift_app_delivery_date']+this.language['common.cannotEmpty']);
             return ;
          }
          for (let i = 0; i < appDeliveryList.length; i++) {
            let item = appDeliveryList[i];
            if (this.model.startAt > item.startTime){
              this.$message.error(this.language['gift_app_time_error_3']);
              return ;
            }
            if (item.startTime > item.endTime){
              this.$message.error(this.language['gift_app_time_error_4']);
              return ;
            }
            if (item.endAt < item.endTime){
              this.$message.error(this.language['gift_app_error_5']);
              return ;
            }
          }


          return new Promise((resolve,reject)=>{
            Promise.all([
            ]).then(() => {
              resolve(allValues)
            }).catch(e => {
              if (e.error === VALIDATE_NO_PASSED) {
                // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
                this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
              } else {
                console.error(e)
              }
            })
          })
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          appDeliveryList: allValues.tablesValue[0].values,
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },

    }
  }
</script>

<style scoped>
</style>